import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../api.js';

interface Org {
  id: string;
  name: string;
  slug: string;
  role: string;
}

export function SelectOrg() {
  const { t } = useTranslation('common');
  const { data, isLoading } = useQuery({
    queryKey: ['orgs'],
    queryFn: () => api<{ orgs: Org[] }>('/orgs'),
  });
  if (isLoading) return <p>{t('loading')}</p>;
  return (
    <div className="mx-auto max-w-md">
      <h1 className="mb-4 text-xl font-semibold">Selecciona una organización</h1>
      <ul className="space-y-2">
        {data?.orgs.map((o) => (
          <li key={o.id}>
            <button
              type="button"
              onClick={async () => {
                await api('/orgs/switch', {
                  method: 'POST',
                  body: JSON.stringify({ orgId: o.id }),
                });
                window.location.href = '/app';
              }}
              className="w-full rounded border bg-white p-3 text-left hover:bg-slate-50"
            >
              <strong>{o.name}</strong> <span className="text-xs text-slate-500">({o.role})</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
